module.exports = __webpack_public_path__ + "img/maestro.146a0d4f.png";